export interface ServicePoint {
  name: string;
  address: string[];
  phones?: string[];
  email?: string;
  website?: string;
}

export interface ProvinceNetwork {
  province: string;
  servicePoints: ServicePoint[];
}

export interface RegionNetwork {
  region: string;
  provinces: ProvinceNetwork[];
}

export const SERVICE_NETWORK: RegionNetwork[] = [
  {
    region: 'Andalucía',
    provinces: [
      {
        province: 'Almería',
        servicePoints: [
          {
            name: 'Blade Informática',
            address: ['C. Granada, 137', '04008 Almería'],
            phones: ['619 56 99 13'],
            email: 'indagfx@gmail.com',
            website: 'https://bladeinformatica.es'
          },
          {
            name: 'Ekoelectric Imporexpor SL',
            address: ['C/ El Salvador, 7, Local H', '04740 Roquetas de Mar, Almería'],
            phones: ['965 79 93 72'],
            email: 'info@ekoe.es',
            website: 'https://ekoe.es'
          },
          {
            name: 'Bicis y Patinetes Salah',
            address: ['135 Avenida', '04700 El Ejido, Almería'],
            phones: ['687 08 60 07'],
            email: 'patinete.salah@gmail.com'
          }
        ]
      },
      {
        province: 'Cádiz',
        servicePoints: [
          {
            name: 'ZonaChip Jerez',
            address: ['C. Sevilla, 10-14, Local 3', '11402 Jerez de la Frontera, Cádiz'],
            phones: ['722 43 01 97'],
            email: 'zonachipjerez@zonachip.com',
            website: 'https://www.zonachip.com'
          },
          {
            name: 'ZonaChip El Puerto de Santa María',
            address: ['C. Ganado, 104', '11500 El Puerto de Santa María, Cádiz'],
            phones: ['655 27 53 05'],
            email: 'info@zonachip.com',
            website: 'https://zonachip.com'
          },
          {
            name: 'ZonaChip Cádiz',
            address: ['Av. Cayetano del Toro, 27, pasaje izquierdo', '11010 Cádiz'],
            phones: ['655 27 53 05'],
            email: 'info@zonachip.com',
            website: 'https://zonachip.com'
          },
          {
            name: 'ZonaChip San Fernando',
            address: ['Av. Almirante León Herrero, 13A', '11100 San Fernando, Cádiz'],
            phones: ['722 43 04 73', '722 43 04 74'],
            email: 'sanfernando@zonachip.com',
            website: 'https://zonachip.com'
          },
          {
            name: 'Hobbymacias',
            address: ['Av. del Descubrimiento, 114', '11130 Chiclana de la Frontera, Cádiz'],
            phones: ['956 40 15 18'],
            email: 'contacto@hobbymacias.es',
            website: 'https://www.hobbymacias.es'
          }
        ]
      },
      {
        province: 'Córdoba',
        servicePoints: [
          {
            name: 'JVD Computers',
            address: ['Av. Santa Ana, 29', '14700 Palma del Río, Córdoba'],
            phones: ['608 967 642'],
            email: 'info@jvdcomputers.com'
          }
        ]
      },
      {
        province: 'Granada',
        servicePoints: [
          {
            name: 'Ecowatts',
            address: ['C. José Recuerda, 3, Local 6', '18004 Granada'],
            phones: ['958 03 01 55'],
            email: 'ges.ecowatts@gmail.com'
          },
          {
            name: 'Full Electric Motril Centro',
            address: ['C. Nueva, 27, Local B', '18600 Motril, Granada'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Motril',
            address: ['C. San Cristóbal, 1', '18600 Motril, Granada'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Nevada Shopping',
            address: ['Avenida de las Palmeras, 75, Nevada Shopping, Local 282', '18100 Armilla, Granada'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          }
        ]
      },
      {
        province: 'Huelva',
        servicePoints: [
          {
            name: 'Onuba Mobility',
            address: ['C. Nicolás Orta, 85', '21006 Huelva'],
            phones: ['959 73 70 77'],
            email: 'empresa@onubamobility.com',
            website: 'https://www.onubamobility.com'
          },
          {
            name: 'Yoyo Ciclos',
            address: ['Carretera de Calañas, 15', '21600 Valverde del Camino, Huelva'],
            phones: ['670 96 50 96'],
            email: 'contacto@yoyociclos.es',
            website: 'https://yoyociclos.es'
          }
        ]
      },
      {
        province: 'Jaén',
        servicePoints: [
          {
            name: 'Servicio Patín',
            address: ['Av. Arjona, 10', '23006 Jaén'],
            phones: ['722 34 44 27'],
            email: 'javier.amaro77@hotmail.com'
          }
        ]
      },
      {
        province: 'Málaga',
        servicePoints: [
          {
            name: 'Full Electric Málaga Centro',
            address: ['C. Mármoles, 63', '29008 Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Armengual',
            address: ['C. Armengual de la Mota, 41', '29007 Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Huelin',
            address: ['C. Salitre, 26', '29002 Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Antonio Gaudí',
            address: ['Av. Antonio Gaudí, 14', '29004 Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Concepción Arenal',
            address: ['C. Concepción Arenal, 24', '29004 Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Torre del Mar',
            address: ['Paseo Marítimo, 44', '29740 Torre del Mar, Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Torre del Mar Levante',
            address: ['Paseo Marítimo de Levante, Conjunto El Copa B, Local 7', '29740 Torre del Mar, Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Vélez',
            address: ['C. Abandolá, s/n', '29700 Vélez-Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Full Electric Nerja',
            address: ['C. Castilla Pérez, 20', '29780 Nerja, Málaga'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Green Bikes',
            address: ['C. Jacinto Benavente, 5, Local 1B', '29601 Marbella, Málaga'],
            phones: ['662 416 599'],
            email: 'greenbikesrent@gmail.com'
          }
        ]
      },
      {
        province: 'Sevilla',
        servicePoints: [
          {
            name: 'Vikings Mobility SL',
            address: ['Avenida de Hytasa, 133', '41006 Sevilla'],
            phones: ['955 41 65 83'],
            email: 'vikingsmobility@gmail.com'
          },
          {
            name: 'Taller-Me',
            address: ['C. Marcos Híades de Acosta, 8', '41010 Sevilla'],
            phones: ['640 19 31 49'],
            email: 'tallermespain@gmail.com'
          },
          {
            name: 'Moviraider Sevilla – Plaza de Armas',
            address: ['Av. Cristo de la Expiración, 1', '41001 Sevilla'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          },
          {
            name: 'Moviraider Sevilla – Macarena',
            address: ['Av. Dr. Fedriani, 45', '41009 Sevilla'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          },
          {
            name: 'Moviraider Sevilla – Sevilla Este',
            address: ['Av. de las Ciencias, 17', '41020 Sevilla'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          },
          {
            name: 'Moviraider Sevilla – Nervión',
            address: ['Av. de Andalucía, 8', '41005 Sevilla'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          },
          {
            name: 'Moviraider Sevilla – Central',
            address: ['C. Resolana, 28', '41009 Sevilla'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Aragón',
    provinces: [
      {
        province: 'Huesca',
        servicePoints: [
          {
            name: 'Nogara',
            address: ['Calle José María Lacasa, 19, Local', '22001 Huesca'],
            phones: ['633 19 55 61']
          }
        ]
      }
    ]
  },
  {
    region: 'Asturias',
    provinces: [
      {
        province: 'Asturias',
        servicePoints: [
          {
            name: 'Me lo pido ya',
            address: ['Av. Schulz, 212, Centro', '33210 Gijón, Asturias'],
            phones: ['675 06 06 45'],
            email: 'melopidogijon@gmail.com',
            website: 'https://www.melopidoya.com'
          },
          {
            name: 'Sabway Gijón',
            address: ['Calle Magnus Blikstad, 44', '33207 Gijón, Asturias'],
            phones: ['684 60 44 41'],
            email: 'gijon@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Sabway Oviedo',
            address: ['Arquitecto Reguera, 13 Bajo 2', '33004 Oviedo, Asturias'],
            phones: ['684 60 70 91'],
            email: 'oviedo@sabway.es',
            website: 'https://sabway.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Cantabria',
    provinces: [
      {
        province: 'Cantabria',
        servicePoints: [
          {
            name: 'Volt Urban',
            address: ['Calle Antonio López, 46', '39009 Santander, Cantabria'],
            phones: ['942 690 788'],
            email: 'volturbansantander@gmail.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Castilla-La Mancha',
    provinces: [
      {
        province: 'Ciudad Real',
        servicePoints: [
          {
            name: 'Talleres Camacho',
            address: ['C. Veracruz, 69', '13300 Valdepeñas, Ciudad Real'],
            phones: ['926 32 40 65'],
            email: 'camacholopez.jm@gmail.com'
          },
          {
            name: 'Sabway Alcázar de San Juan',
            address: ['Av. Álvarez Guerra, 6', '13600 Alcázar de San Juan, Ciudad Real'],
            phones: ['675 10 10 10'],
            email: 'alcazar@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Hurtado Bikes',
            address: ['Clemente Cuesta Santandreu, 18, Local 2', '13700 Tomelloso, Ciudad Real'],
            phones: ['644 36 43 71'],
            email: 'hurtadobikes@gmail.com',
            website: 'https://hurtadobikes.es'
          }
        ]
      },
      {
        province: 'Toledo',
        servicePoints: [
          {
            name: 'Moviraider Toledo – Yuncos',
            address: ['C. Real, 161', '45210 Yuncos, Toledo'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Castilla y León',
    provinces: [
      {
        province: 'Ávila',
        servicePoints: [
          {
            name: 'Electrochumba',
            address: ['C/ Soria, 6', '05003 Ávila'],
            phones: ['642 54 75 84'],
            email: 'electrochumba@gmail.com',
            website: 'https://www.electrochumba.es'
          }
        ]
      },
      {
        province: 'Burgos',
        servicePoints: [
          {
            name: 'Ecomobility Green World',
            address: ['Calle del Enebro, 2 Bajo', '09007 Burgos'],
            phones: ['640 681 120'],
            email: 'burgos@movelectrica.com',
            website: 'https://movelectrica.com'
          },
          {
            name: 'Emision Zero',
            address: ['C/ Madrid, 62 Bajo', '09001 Burgos'],
            phones: ['614 163 405'],
            email: 'info@emisionzero.com'
          }
        ]
      },
      {
        province: 'León',
        servicePoints: [
          {
            name: 'RT Bros. Movilidad Urbana',
            address: ['C/ Covadonga, 6, Local 2', '24004 León'],
            phones: ['611 02 98 95'],
            email: 'rtbrosleon@gmail.com',
            website: 'https://rtbros.es'
          }
        ]
      },
      {
        province: 'Palencia',
        servicePoints: [
          {
            name: 'Eco Electrónica',
            address: ['Av. República Argentina, 6', '34002 Palencia'],
            phones: ['601 398 785'],
            email: 'esmm159@gmail.com'
          }
        ]
      },
      {
        province: 'Salamanca',
        servicePoints: [
          {
            name: 'Patinete Charro',
            address: ['Fernando de la Peña, 28', '37005 Salamanca'],
            phones: ['611 748 896'],
            email: 'elpatinetecharro@gmail.com'
          }
        ]
      },
      {
        province: 'Valladolid',
        servicePoints: [
          {
            name: 'Sabway Valladolid',
            address: ['Camino de la Esperanza, 22 Bajo', '47007 Valladolid'],
            phones: ['658 127 982'],
            email: 'valladolid@sabway.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Ceuta y Melilla',
    provinces: [
      {
        province: 'Ceuta',
        servicePoints: [
          {
            name: 'Electrónica Ceuta',
            address: ['Calle Fernández, 3 Bajo', '51005 Ceuta'],
            phones: ['956 514 432'],
            email: 'electronicaceuta@gmail.com',
            website: 'https://www.electronicaceuta.net'
          }
        ]
      },
      {
        province: 'Melilla',
        servicePoints: [
          {
            name: 'BEEP Melilla',
            address: ['Av. General Aizpuru, 22 Bajo Izquierda', '52004 Melilla'],
            phones: ['952 677 437'],
            email: 'bmelilla2@beep.es',
            website: 'https://www.beep.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Cataluña',
    provinces: [
      {
        province: 'Barcelona',
        servicePoints: [
          {
            name: 'PitStop',
            address: ['Carrer de Malgrat, 65', '08016 Barcelona'],
            phones: ['649 86 40 07'],
            email: 'hola@reparartupatinete.com',
            website: 'https://reparartupatinete.com'
          },
          {
            name: 'Urban Scooter Gràcia',
            address: ['Travessera de Gràcia, 335', '08025 Barcelona'],
            phones: ['633 70 56 40'],
            email: 'ventas@isgsafety.com',
            website: 'https://urbanscooterbcn.com'
          },
          {
            name: 'Urban Scooter Eixample',
            address: ['C/ de la Diputació, 10', '08015 Barcelona'],
            phones: ['693 10 07 75'],
            email: 'ventas@isgsafety.com',
            website: 'https://urbanscooterbcn.com'
          },
          {
            name: 'Electrónica Fabregat',
            address: ['Carrer dels Sagarra, 33', '08922 Santa Coloma de Gramenet, Barcelona'],
            phones: ['933 86 20 80'],
            email: 'electronica.fabregat@gmail.com'
          },
          {
            name: 'EcoLife Cornellà',
            address: ['Av. del Parc, 51', '08940 Cornellà de Llobregat, Barcelona'],
            phones: ['632 32 04 03', '631 52 47 92'],
            email: 'ecolife1006@gmail.com'
          },
          {
            name: 'Cel Blau Mobility',
            address: ['Carrer de l’Església, 45', '08860 Castelldefels, Barcelona'],
            phones: ['677 79 70 07', '936 55 55 99'],
            email: 'info@cel-blau.cat'
          },
          {
            name: 'ECO RODES',
            address: ['Carrer dels Voluntaris, 79, Bajo 2', '08225 Terrassa, Barcelona'],
            phones: ['935 84 24 76', '681 96 41 61'],
            email: 'ecorodes@ecorodes.es',
            website: 'https://www.ecorodes.es'
          },
          {
            name: 'Bike Box',
            address: ['Carrer de la Saboneria, 7-9', '08204 Sabadell, Barcelona'],
            phones: ['622 22 77 05', '935 66 80 58'],
            email: 'info@bike-box.es'
          },
          {
            name: 'Le Mur Bikes',
            address: ['Carrer Dr. Lluís Gaya, 3', '08760 Martorell, Barcelona'],
            phones: ['932 50 49 60'],
            email: 'lemurbikes@hotmail.com'
          },
          {
            name: 'TARYA Bikes',
            address: ['Ctra. Vella, 1', '08470 Sant Celoni, Barcelona'],
            phones: ['633 63 82 60'],
            email: 'taryaebikes@gmail.com'
          },
          {
            name: 'ISG Safety',
            address: ['Travessera de Gràcia, 335', '08025 Barcelona'],
            phones: ['693 10 07 75'],
            email: 'ventas@isgsafety.com',
            website: 'https://isgsafety.com'
          },
          {
            name: 'Sabway Vic',
            address: ['Carrer del Bisbe Morgades, 12 Baixos', '08500 Vic, Barcelona'],
            phones: ['621 28 51 67'],
            email: 'vic@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Sabway Santa Perpètua',
            address: ['Avda. Onze de Setembre, 36, Local 2', '08130 Santa Perpètua de Mogoda, Barcelona'],
            phones: ['660 39 27 12'],
            email: 'santaperpetua@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Eco.life El Prat',
            address: ['Carrer de Frederic Soler, 54', '08820 El Prat de Llobregat, Barcelona'],
            phones: ['632 32 04 03'],
            email: 'ecolife1006@gmail.com',
            website: 'https://eco-life.es'
          },
          {
            name: 'Tienda Zwheel Barcelona',
            address: ['Gran Via de les Corts Catalanes, 745-747', '08013 Barcelona'],
            phones: ['635 22 47 37'],
            website: 'https://tiendabarcelona.zwheel.com'
          },
          {
            name: 'Sabway Viladomat',
            address: ['Calle Viladomat, 97, Local 1', '08015 Barcelona'],
            phones: ['646 052 258'],
            email: 'viladomat@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Passion Bike',
            address: ['Penedès, 2', '08191 Rubí, Barcelona'],
            phones: ['936 970 367'],
            email: 'passion.bike@hotmail.com',
            website: 'https://passionbikesport.com'
          },
          {
            name: 'Top Mechanic',
            address: ['Carretera de Vic, 134', '08243 Manresa, Barcelona'],
            phones: ['634 863 827']
          },
          {
            name: 'Ecoenergetic Sabadell',
            address: ['Carrer de Margenat, 1', '08206 Sabadell, Barcelona'],
            phones: ['937 244 317'],
            email: 'janpolecoenergic@gmail.com'
          }
        ]
      },
      {
        province: 'Girona',
        servicePoints: [
          {
            name: 'Patinete ST',
            address: ['Carrer Juli Garreta, 3, Galerías Albatros 121', '17250 Platja d’Aro, Girona'],
            phones: ['872 41 82 06'],
            email: 'alberto@patinete-st.com'
          },
          {
            name: 'LARODA',
            address: ['Carretera de la Canya, 93', '17800 Olot, Girona'],
            phones: ['690 02 24 24'],
            email: 'larodaskates@gmail.com',
            website: 'https://www.larodaskates.com'
          },
          {
            name: 'LA9 Urban Sports',
            address: ['C/ Barcelona, 123', '17003 Girona'],
            phones: ['972 909 033'],
            email: 'girona@la9urbansports.com',
            website: 'https://la9urbansports.com'
          }
        ]
      },
      {
        province: 'Lleida',
        servicePoints: [
          {
            name: 'GS Ilertronics',
            address: ['C. Príncipe de Viana, 68, Bajos', '25008 Lleida'],
            phones: ['973 09 58 48', '722 82 26 77'],
            email: 'jmgodia@gsilertronics.com',
            website: 'https://www.gsilertronics.com'
          }
        ]
      },
      {
        province: 'Tarragona',
        servicePoints: [
          {
            name: 'Taller del Patinete Tarragona',
            address: ['Av. de Ramón y Cajal, 51', '43005 Tarragona'],
            phones: ['688 72 77 22'],
            email: 'patineteelectricotgn@gmail.com'
          },
          {
            name: 'Taller del Patinete Reus',
            address: ['Pg. de Prim, 29', '43202 Reus, Tarragona'],
            phones: ['657 62 86 49'],
            email: 'patineteelectricotgn@gmail.com'
          },
          {
            name: 'Esports Mañé',
            address: ['Avinguda de Barcelona, 136', '43892 Miami Platja, Tarragona'],
            phones: ['977 81 09 21']
          },
          {
            name: 'My Scooter',
            address: ['Passeig Sant Joan Baptista de la Salle, 8A Bajo 2', '43850 Cambrils, Tarragona'],
            phones: ['611 18 99 32'],
            email: 'myscootercambrils@gmail.com',
            website: 'https://myscootershop.es'
          },
          {
            name: 'BikesandBeach',
            address: ['Av. Palfuriana, 111', '43880 Sant Salvador, Tarragona'],
            phones: ['691 93 22 23'],
            email: 'direccion@bikesandbeach.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Comunidad Valenciana',
    provinces: [
      {
        province: 'Alicante',
        servicePoints: [
          {
            name: 'Bici-Club',
            address: ['Avda. Beniardá, 55, Local 2', '03502 Benidorm, Alicante'],
            phones: ['965 85 11 35'],
            email: 'dani_biciclub@hotmail.com',
            website: 'https://bicicletasbenidorm.com'
          },
          {
            name: 'The Search Ecovoltaje',
            address: ['C/ Teodor Llorente, 30', '03201 Elche, Alicante'],
            phones: ['633 87 67 83'],
            email: 'ecovoltajelche@gmail.com'
          },
          {
            name: 'Taller del Patinete Alicante',
            address: ['C/ Bono Guarner, 28, Local Izq.', '03005 Alicante'],
            phones: ['633 84 60 84'],
            email: 'alicante@patinetecenter.es',
            website: 'https://tallerdelpatinete.es'
          }
        ]
      },
      {
        province: 'Castellón',
        servicePoints: [
          {
            name: 'Electric BLO',
            address: ['Avinguda de Jacinto Benavente, 20', '12580 Benicarló, Castellón'],
            phones: ['642 05 20 10'],
            email: 'electricblo2021@gmail.com'
          },
          {
            name: 'LIONTEC Asensi',
            address: ['Carrer d’Asensi, 4', '12002 Castelló de la Plana, Castellón'],
            phones: ['642 25 55 69', '642 41 48 00'],
            email: 'liontechelectric@gmail.com',
            website: 'https://www.liontec.es'
          },
          {
            name: 'LIONTEC Valencia',
            address: ['Avenida de Valencia, 44', '12006 Castelló de la Plana, Castellón'],
            phones: ['614 326 566'],
            email: 'liontechelectric@gmail.com',
            website: 'https://www.liontec.es'
          },
          {
            name: 'Electricmoving',
            address: ['Avenida Serrano Lloveras, 4', '12100 El Grao de Castellón, Castellón'],
            phones: ['964 28 24 49'],
            email: 'motor@morenauto.com',
            website: 'https://www.talleresmorenauto.com'
          },
          {
            name: 'Smart Mobility Systems Castellón',
            address: ['Av. de València, 189', '12005 Castelló de la Plana, Castellón'],
            phones: ['964 24 10 74'],
            email: 'info@smselectrics.com',
            website: 'https://www.smselectrics.com'
          },
          {
            name: 'Smart Mobility Systems Villarreal',
            address: ['Av. Francesc Tàrrega, 45', '12540 Vila-real, Castellón'],
            phones: ['964 24 10 74'],
            email: 'info@smselectrics.com',
            website: 'https://www.smselectrics.com'
          },
          {
            name: 'VinFix',
            address: ['San Jaime, 11', '12500 Vinaròs, Castellón'],
            phones: ['675 73 57 01'],
            email: 'info@vinfix.es',
            website: 'https://vinfix.es'
          },
          {
            name: 'Sabway Castellón',
            address: ['Calle Ronda Mijares, 19', '12001 Castelló'],
            phones: ['635 55 60 81'],
            email: 'castellon@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Elecosystems',
            address: ['Calle Carcagente, 10', '12005 Castellón de la Plana, Castellón'],
            phones: ['637 20 42 41'],
            email: 'serviciopostventaelecosystems@gmail.com',
            website: 'https://elecosystems.com'
          }
        ]
      },
      {
        province: 'Valencia',
        servicePoints: [
          {
            name: 'Altovoltaje',
            address: ['C/ de les Tres Forques, 69, Bajo', '46018 Valencia'],
            phones: ['611 49 96 48'],
            email: 'info@altovoltaje.store',
            website: 'https://www.altovoltaje.store'
          },
          {
            name: 'Patinetes JDG',
            address: ['Av. Rei Jaume I, 6A', '46470 Catarroja, Valencia'],
            phones: ['611 66 76 77'],
            email: 'julio@patinetesjdg.com',
            website: 'https://patinetesjdg.com'
          },
          {
            name: 'Moviraider Valencia',
            address: ['C/ de Padilla, 8, Ciutat Vella', '46001 Valencia'],
            phones: ['642 615 574'],
            email: 'hola@moviraider.es'
          },
          {
            name: 'Casella Mobile',
            address: ['Carrer de Trinitat Redal Dufaur, 65', '46600 Valencia'],
            phones: ['610 378 974'],
            email: 'casellamobileshop@gmail.com'
          }
        ]
      }
    ]
  },
  {
    region: 'País Vasco',
    provinces: [
      {
        province: 'Álava',
        servicePoints: [
          {
            name: 'Patinetes Vitoria',
            address: ['Domingo Beltrán de Otazu Kalea, 7, Local 2', '01012 Vitoria-Gasteiz, Álava'],
            phones: ['692 58 70 56', '945 02 88 44'],
            email: 'patinetesvitoria@gmail.com',
            website: 'https://www.patinetesvitoria.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Extremadura',
    provinces: [
      {
        province: 'Badajoz',
        servicePoints: [
          {
            name: 'Sabway Mérida',
            address: ['Avenida de la Constitución, 36, Local 3', '06800 Mérida, Badajoz'],
            phones: ['601 544 778'],
            email: 'merida@sabway.es',
            website: 'https://sabway.es'
          }
        ]
      },
      {
        province: 'Cáceres',
        servicePoints: [
          {
            name: 'Taller-Me',
            address: ['Av. Isabel de Moctezuma, 29', '10005 Cáceres'],
            phones: ['623 06 34 29'],
            email: 'tallermespain@gmail.com',
            website: 'https://reynielhdz89.wixsite.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Galicia',
    provinces: [
      {
        province: 'Pontevedra',
        servicePoints: [
          {
            name: 'EKOLOGIK',
            address: ['Calle Barcelona, 36A Bajo', '36203 Vigo, Pontevedra'],
            phones: ['722 48 37 42'],
            email: 'distribuidores@ekologik.es',
            website: 'https://ekologik.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Illes Balears',
    provinces: [
      {
        province: 'Illes Balears',
        servicePoints: [
          {
            name: 'Voltion',
            address: ['Avda. Argentina, 16, Bajo Derecha', '07011 Palma de Mallorca, Illes Balears'],
            phones: ['971 07 46 81'],
            email: 'info@voltion.es',
            website: 'https://www.voltion.es'
          },
          {
            name: 'Radio Avenida Ibiza',
            address: ['Ca n’Escandell, Carrer d’Atzaró, 13', '07800 Ibiza, Illes Balears'],
            phones: ['971 30 03 91', '971 39 80 27'],
            email: 'comercial@radioavenida.es',
            website: 'https://www.radioavenida.es'
          },
          {
            name: 'Radio Avenida Centro',
            address: ['Avenida Espanya, 45, Local 1 y 2', '07800 Ibiza, Illes Balears'],
            phones: ['971 30 03 91'],
            email: 'comercial@radioavenida.es',
            website: 'https://www.radioavenida.es'
          },
          {
            name: 'App-Informática Menorca',
            address: ['Avinguda de Jaume I el Conqueridor, 5', '07760 Ciutadella de Menorca, Illes Balears'],
            phones: ['606 81 18 38', '971 48 18 18'],
            email: 'appinformaticamenorca@gmail.com',
            website: 'https://www.appinformatica.com'
          },
          {
            name: 'Divermodel',
            address: ['C/ Gaspar Rullán, 10', '07600 Palma de Mallorca, Illes Balears'],
            phones: ['971 44 21 38'],
            email: 'contacto@rcdivermodel.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Canarias',
    provinces: [
      {
        province: 'Canarias',
        servicePoints: [
          {
            name: 'MotoBike Lanzarote Tías',
            address: ['Av. de las Playas, 78', '35510 Tías, Las Palmas'],
            phones: ['928 51 70 94', '647 16 64 29'],
            email: 'motobikelanzarote@gmail.com',
            website: 'https://www.motobikelanzarote.com'
          },
          {
            name: 'MotoBike Lanzarote Playa Blanca',
            address: ['Centro Comercial Lanzarote Park, Av. Archipiélago, 7, Local 2', '35580 Playa Blanca, Las Palmas'],
            phones: ['928 51 70 94'],
            email: 'motobikelanzarote@gmail.com',
            website: 'https://www.motobikelanzarote.com'
          },
          {
            name: 'Aeropatin',
            address: ['P.º de Tomás Morales, 72', '35003 Las Palmas de Gran Canaria'],
            phones: ['655 78 73 00'],
            email: 'info@aeropatin.com',
            website: 'https://www.aeropatin.com'
          },
          {
            name: 'Microtech SAT',
            address: ['C. San Antonio, 40, Bajo Izquierda', '38001 Santa Cruz de Tenerife'],
            phones: ['822 04 25 18'],
            email: 'microtechsat001@gmail.com',
            website: 'https://microtechsat.com'
          },
          {
            name: 'Patinete Doctor Sur Costa Adeje',
            address: ['C. Gran Bretaña, 6', '38660 Costa Adeje, Santa Cruz de Tenerife'],
            phones: ['643 96 26 04'],
            email: 'patinetedoctorsur@gmail.com'
          },
          {
            name: 'Patinete Doctor Sur Arona',
            address: ['Av. de Suecia, 20', '38650 Arona, Santa Cruz de Tenerife'],
            phones: ['643 96 26 04'],
            email: 'patinetedoctorsur@gmail.com'
          }
        ]
      }
    ]
  },
  {
    region: 'La Rioja',
    provinces: [
      {
        province: 'La Rioja',
        servicePoints: [
          {
            name: 'Patinetes Rioja',
            address: ['Calle General Vara de Rey, 53', '26002 Logroño'],
            phones: ['727 707 890'],
            email: 'patinetesrioja@gmail.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Madrid',
    provinces: [
      {
        province: 'Madrid',
        servicePoints: [
          {
            name: 'Sabway Quintana',
            address: ['Calle Virgen del Sagrario, 5', '28027 Madrid'],
            phones: ['656 903 887'],
            email: 'madrid2@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'Sabway Majadahonda',
            address: ['Santa Catalina, 15, Local D', '28220 Majadahonda, Madrid'],
            phones: ['671 573 261'],
            email: 'majadahonda@sabway.es',
            website: 'https://sabway.es'
          },
          {
            name: 'SABWAY Madrid',
            address: ['Calle Cartagena, 57', '28028 Madrid'],
            phones: ['626 908 313'],
            email: 'info@vmphub.es',
            website: 'https://vmphub.es'
          },
          {
            name: 'Full Electric Alcorcón',
            address: ['Calle Oslo, 53, Planta -1, Local 9C', '28922 Alcorcón, Madrid'],
            phones: ['658 38 38 78'],
            email: 'fulltecnielectric@gmail.com',
            website: 'https://www.etronscooter.com'
          },
          {
            name: 'Reborn Systems S.L.',
            address: ['Calle Libertad, 15 Local', '28850 Torrejón de Ardoz, Madrid'],
            phones: ['916 761 550'],
            email: 'info@madridrueda.es'
          }
        ]
      }
    ]
  },
  {
    region: 'Murcia',
    provinces: [
      {
        province: 'Murcia',
        servicePoints: [
          {
            name: 'JM Mobility Urban',
            address: ['C. Floridablanca, 56, Barrio del Carmen', '30002 Murcia'],
            phones: ['693 30 05 96', '604 44 43 81'],
            email: 'jmmobilityurban@gmail.com'
          },
          {
            name: 'Sotroni Lorca Centro',
            address: ['C. Jerónimo Sta. Fe, 5', '30800 Lorca, Murcia'],
            phones: ['968 46 82 31', '968 47 79 24'],
            email: 'administracion@sotroni.es',
            website: 'https://sotroni.es'
          },
          {
            name: 'Sotroni Lorca Polígono',
            address: ['Pol. Ind. Los Peñones, Ctra. de Granada', '30817 Lorca, Murcia'],
            phones: ['968 46 82 31'],
            email: 'administracion@sotroni.es',
            website: 'https://sotroni.es'
          },
          {
            name: 'Sinertelecom',
            address: ['Avenida de Madrid, 42, Bajo', '30500 Molina de Segura, Murcia'],
            phones: ['605 309 548'],
            email: 'administracion@sinertelecom.es'
          },
          {
            name: 'Motos Yeray Yecla',
            address: ['Infanta María Teresa, 12, Bajo', '30510 Yecla, Murcia'],
            phones: ['868 12 05 22'],
            email: 'info@motosyeray.es'
          },
          {
            name: 'Motos Yeray Jumilla',
            address: ['Avenida de Levante, 9', '30520 Jumilla, Murcia'],
            phones: ['868 12 05 22'],
            email: 'info@tutiendadelpatinete.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Navarra',
    provinces: [
      {
        province: 'Navarra',
        servicePoints: [
          {
            name: 'EKO Movilidad Eléctrica',
            address: ['Avenida Baja Navarra, 22, Bajo', '31004 Pamplona, Navarra'],
            phones: ['643 214 472'],
            email: 'ekomovilidadelectrica@gmail.com',
            website: 'https://www.patineteselectricospamplona.com'
          }
        ]
      }
    ]
  },
  {
    region: 'Portugal',
    provinces: [
      {
        province: 'Portugal',
        servicePoints: [
          {
            name: 'Martins Tech',
            address: ['Praça do Comércio, 49 R/C DRT', '3515-847 Viseu, Portugal'],
            phones: ['+351 939 087 811'],
            email: 'fornecedores@martinstech.pt'
          }
        ]
      }
    ]
  }
];
